import { Box } from '@/components/Box/Box';
import { NavigationStepper } from '@/components/NavigationStepper/NavigationStepper';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { isActiveRoute } from '@/bundle/Sidebar/helpers/helpers';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { AdminOnboardingCircleStepBar } from '@/bundle/Auth/AdminOnboardingFlow/ui/AdminOnboardingCircleStepBar';
import { SignUpStepType } from '@/const/shared';
import { ONBOARDING_NAVIGATION_STEPS_MAP, OnboardingNavigationStep } from './const';

type AdminOnboardingStepperType = {
  signUpStep: SignUpStepType;
};

export const AdminOnboardingStepper = ({ signUpStep }: AdminOnboardingStepperType) => {
  const { pathname } = useLocation();
  const { isMobile } = useResponsiveDevice();
  const [onboardingSteps, setOnboardingSteps] = useState([]);

  useEffect(() => {
    const steps = ONBOARDING_NAVIGATION_STEPS_MAP[signUpStep] ?? [];
    const currentStepIndex = steps.findIndex((step: OnboardingNavigationStep) => isActiveRoute(pathname, step.path));

    if (currentStepIndex === -1) return;

    const updatedNavigationSteps = steps.map((step: OnboardingNavigationStep, index: number) => {
      return {
        ...step,
        isActive: index === currentStepIndex,
        isCompleted: index < currentStepIndex,
      };
    });

    setOnboardingSteps(updatedNavigationSteps);
  }, [pathname, signUpStep]);

  const currentStep = onboardingSteps.find((step) => step.isActive);
  const currentStepCount = currentStep?.count;
  const nextStep = onboardingSteps[currentStepCount];

  return (
    <Box display='flex' justifyContent='center' padding='26px 22px 20px' mobile={{ padding: '16px' }}>
      {isMobile ? (
        <AdminOnboardingCircleStepBar
          count={currentStepCount}
          totalCount={onboardingSteps.length}
          currentStep={currentStep?.title}
          nextStep={nextStep?.title}
        />
      ) : (
        <NavigationStepper steps={onboardingSteps} />
      )}
    </Box>
  );
};
